import React from 'react';
import { BarChart3, Package, ListChecks, TrendingUp, CheckCircle2 } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <ListChecks size={32} />,
      title: 'Order Management',
      description: 'Streamline your order processing with automated workflows, bulk actions, and real-time status tracking across all your TikTok Shop orders.',
    },
    {
      icon: <Package size={32} />,
      title: 'Product Sync',
      description: 'Effortlessly synchronize your product catalog across multiple platforms. Update pricing, descriptions, and images in one place.',
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Inventory Tracking',
      description: 'Never oversell again. Get real-time inventory updates, low stock alerts, and automated reordering suggestions.',
    },
    {
      icon: <BarChart3 size={32} />,
      title: 'Data Analytics',
      description: 'Make data-driven decisions with comprehensive analytics, sales insights, and performance metrics tailored for TikTok Shop sellers.',
    },
  ];

  return (
    <div className="page-content page-top">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">Powerful Features</h1>
          <p className="page-subtitle">
            Everything you need to manage and grow your TikTok Shop business in one comprehensive platform.
          </p>
        </div>

        <div className="features-list">
          {features.map((feature, index) => (
            <div key={index} className="feature-detail-card">
              <div className="feature-detail-icon">
                {feature.icon}
              </div>
              <div className="feature-detail-content">
                <h3 className="feature-detail-title">{feature.title}</h3>
                <p className="feature-detail-description">{feature.description}</p>
                <ul className="feature-checklist">
                  <li><CheckCircle2 size={20} /> Real-time synchronization</li>
                  <li><CheckCircle2 size={20} /> Automated workflows</li>
                  <li><CheckCircle2 size={20} /> Advanced reporting</li>
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="features-cta">
          <a href="#/contact" className="btn btn-primary">
            Request a Demo
          </a>
        </div>
      </div>
    </div>
  );
};

export default Features;
